const red = {
  '50': '#FDE8ED',
  '100': '#F9BDCC',
  '200': '#F693AB',
  '300': '#F2698A',
  '400': '#EE3F69',
  '500': '#EB1448',
  '600': '#BC103A',
  '700': '#8D0C2B',
  '800': '#5E081D',
  '900': '#2F040E',
}

const pink = {
  '50': '#FFE5F0',
  '100': '#FFB8D6',
  '200': '#FF8ABB',
  '300': '#FF5CA0',
  '400': '#FF2E85',
  '500': '#FF006B',
  '600': '#CC0055',
  '700': '#990040',
  '800': '#66002B',
  '900': '#330015',
}

const purple = {
  '50': '#F2EAFA',
  '100': '#DBC5F1',
  '200': '#C4A0E8',
  '300': '#AD7BE0',
  '400': '#9656D7',
  '500': '#7F31CE',
  '600': '#6627A5',
  '700': '#4C1D7C',
  '800': '#331452',
  '900': '#190A29',
}

const blue = {
  '50': '#E5EDFF',
  '100': '#B8CDFF',
  '200': '#8AACFF',
  '300': '#5C8CFF',
  '400': '#2E6CFF',
  '500': '#004BFF',
  '600': '#003CCC',
  '700': '#002D99',
  '800': '#001E66',
  '900': '#000F33',
}

const green = {
  '50': '#E8FDEB',
  '100': '#BEF8C7',
  '200': '#95F4A4',
  '300': '#6BEF80',
  '400': '#42EB5C',
  '500': '#18E739',
  '600': '#13B92D',
  '700': '#0F8A22',
  '800': '#0A5C17',
  '900': '#052E0B',
}

const yellow = {
  '50': '#FFF8E5',
  '100': '#FFEBB8',
  '200': '#FFDE8A',
  '300': '#FFD15C',
  '400': '#FFC42E',
  '500': '#FFB700',
  '600': '#CC9200',
  '700': '#996E00',
  '800': '#664900',
  '900': '#332500',
}

const cyan = {
  '50': '#E5FEFF',
  '100': '#B8FBFF',
  '200': '#8AF8FF',
  '300': '#5CF5FF',
  '400': '#2EF3FF',
  '500': '#00F0FF',
  '600': '#004BFF',
  '700': '#003CCC',
  '800': '#002D99',
  '900': '#001E66',
}

const gray = {
  '0': '#fff',
  '50': '#F1F2F4',
  '100': '#D8DADF',
  '200': '#BEC2CA',
  '300': '#A5AAB6',
  '400': '#8C92A1',
  '500': '#737A8C',
  '600': '#5C6170',
  '700': '#454954',
  '800': '#2E3138',
  '900': '#17181C',
  '1000': '#020202',
}

export default {
  // primary
  blue,
  purple,
  red,
  green,
  // secondary
  cyan,
  yellow,
  gray,
  pink,
}
